export default __webpack_public_path__ + "img/a15ae80eafcaf3c0a388f381d09ed398.svg";